module.exports = __webpack_public_path__ + "img/xiazais.434710a4.png";